import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { declineOneRentAsset } from '@api/assetsRent';

import { ESnackbarTypes } from '@enums/common';

import { ASSET_RENT_REQUEST_CARD_ITEMS } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

export const useMutateDeclineOneRentAsset = (id: string, onSuccessCallbacks: Array<() => void>) => {
	const dispatch = useAppDispatch();

	const {
		mutate: declineProposedAsset,
	} = useMutation<{ assetId: string }>({
		mutationKey: [ASSET_RENT_REQUEST_CARD_ITEMS, id],
		mutationFn: ({ assetId }: { assetId: string }) => declineOneRentAsset(assetId),
		onSuccess: () => {
			dispatch(setSnackbar({
				message: responseMessages.assetRentDeclineProposalItem,
				type: ESnackbarTypes.success,
			}));

			if (onSuccessCallbacks.length) {
				onSuccessCallbacks.forEach((callback) => callback());
			}
		},
	});

	return { declineProposedAsset };
};
